import { initGoogleMaps } from "./js/init-map.js";
window.initGoogleMaps = initGoogleMaps;

import "./scss/frontend.scss";
import "./js/site-header";
import "./js/avail-nav";
import "./js/logos";
import "./js/modals";
import "./js/navigation";
import "./js/smooth-scroll";
import "./js/sliders";
import "./js/projects";
import "./js/countup";
import "./js/responsive";
import "./js/animations";
